<template>
  <div class="ren-decoration-cp ren-decoration-cp-purchase-bar" :style="barStyle">
    <span>{{ sideText }}</span>
    <button type="button" :style="cartStyle">{{ cartText }}</button>
    <button type="button" :style="buyStyle">{{ buyText }}</button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { booleanValue, stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const cartText = computed(() => stringValue(props.component.props?.cartText, '加入购物车'))
const buyText = computed(() => stringValue(props.component.props?.buyText, '立即购买'))
const sideText = computed(() => {
  const parts: string[] = []
  if (booleanValue(props.component.props?.showService, true)) parts.push('客服')
  if (booleanValue(props.component.props?.showFavorite, true)) parts.push('收藏')
  parts.push('购物车')
  return parts.join(' · ')
})
const barStyle = computed(() => {
  const color = stringValue(props.component.style?.cardColor)
  return {
    backgroundColor: color || undefined,
    borderColor: props.themeTokens?.borderColor || 'var(--ren-theme-border)'
  }
})
const cartStyle = computed(() => ({
  backgroundColor: props.themeTokens?.accentColor || props.themeTokens?.primaryColor || 'var(--ren-theme-primary)',
  color: '#fff'
}))
const buyStyle = computed(() => ({
  backgroundColor: props.themeTokens?.primaryColor || props.themeColor || 'var(--ren-theme-primary)',
  color: '#fff'
}))
</script>
